import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

const Index = () => ({
  component: import('@/components/Index'),
  delay: 200,
  timeout: Infinity
})
const Login = () => ({
  component: import('@/components/Login'),
  delay: 200,
  timeout: Infinity
})
const Flyers = () => ({
  component: import('@/components/Flyers'),
  delay: 200,
  timeout: Infinity
})

const Overview = () => ({
  component: import('@/components/Overview'),
  delay: 200,
  timeout: Infinity
})

const BGC = () => ({
  component: import('@/components/BGC'),
  delay: 200,
  timeout: Infinity
})
const BGCRezumat = () => ({
  component: import('@/components/BGC/General'),
  delay: 200,
  timeout: Infinity
})
const BGCVenCh = () => ({
  component: import('@/components/BGC/VenituriCheltuieli'),
  delay: 200,
  timeout: Infinity
})
const BGCStructura = () => ({
  component: import('@/components/BGC/Defalcat'),
  delay: 200,
  timeout: Infinity
})
const BGCTabel = () => ({
  component: import('@/components/BGC/Tabel'),
  delay: 200,
  timeout: Infinity
})

const BL = () => ({
  component: import('@/components/BL'),
  delay: 200,
  timeout: Infinity
})
const BLRezumat = () => ({
  component: import('@/components/BL/General'),
  delay: 200,
  timeout: Infinity
})
const BLVenituri = () => ({
  component: import('@/components/BL/Venituri'),
  delay: 200,
  timeout: Infinity
})
const BLChFct = () => ({
  component: import('@/components/BL/CheltuieliFunctionale'),
  delay: 200,
  timeout: Infinity
})
const BLChEc = () => ({
  component: import('@/components/BL/CheltuieliEconomice'),
  delay: 200,
  timeout: Infinity
})
const BLMatrice = () => ({
  component: import('@/components/BL/Matrice'),
  delay: 200,
  timeout: Infinity
})

const CC = () => ({
  component: import('@/components/CC'),
  delay: 200,
  timeout: Infinity
})

import Dashboard from '@/components/admin/Dashboard'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Login
    },
    {
      path: '/login/:id?',
      name: 'Login',
      component: Login
    },
    {
      path: '/dashboard/:id?',
      name: 'Dashboard',
      component: Dashboard,
      meta: { requiresAuth: true }
    },
    {
      path: '/flyere/:id?',
      name: 'Flyere',
      component: Flyers
    },
    {
      path: '/:id',
      component: Index,
      beforeEnter: (to, from, next) => {
        if (to.params.id) {
          // store.dispatch('getClient', to.params.id)
          next()
        }
      },
      children: [
        { path: '', redirect: 'comunitatea-locala' },
        { path: 'comunitatea-locala', component: Overview, name: 'overview', meta: { dict: 'overview' } },
        {
          path: 'buget-general-centralizat',
          component: BGC,
          children: [
            { path: '', redirect: 'bgc-rezumat' },
            { path: 'bgc-rezumat', components: { rezumat: BGCRezumat, vench: BGCVenCh }, name: 'bgc-rezumat', meta: { dict: 'bgc' } },
            { path: 'bgc-structura', components: { rezumat: BGCStructura, vench: null }, name: 'bgc-structura', meta: { dict: 'bgc' } },
            { path: 'bgc-nivel-realizat', components: { rezumat: BGCTabel, vench: null }, name: 'bgc-nivel-realizat', meta: { dict: 'bgc' } }
          ]
        },
        {
          path: 'buget-local',
          component: BL,
          children: [
            { path: '', redirect: 'bl-rezumat' },
            { path: 'bl-rezumat', components: { content: BLRezumat }, name: 'bl-rezumat', meta: { dict: 'bl' } },
            { path: 'bl-venituri', components: { content: BLVenituri }, name: 'bl-venituri', meta: { dict: 'bl' } },
            { path: 'bl-cheltuieli-functionale', components: { content: BLChFct }, name: 'bl-ch-fct', meta: { dict: 'bl' } },
            { path: 'bl-cheltuieli-economice', components: { content: BLChEc }, name: 'bl-ch-ec', meta: { dict: 'bl' } },
            { path: 'bl-tabel-cheltuieli', components: { content: BLMatrice }, name: 'bl-matrice', meta: { dict: 'bl' } }
          ]
        },
        { path: 'contributia-cetateanului', component: CC, name: 'cc', meta: { dict: 'cc' } }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  let watcher
  if (store.getters.getLoading) {
    watcher = store.watch((state) => store.getters.getLoading, (loading) => {
      proceed()
    })
  } else {
    proceed()
  }

  function proceed () {
    if (watcher) {
      watcher()
    }
    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (store.getters.getUser) {
        next()
      } else {
        next({name: 'Index'})
      }
    } else {
      next()
    }
  }
})

router.afterEach((to, from) => {
  let cs = document.documentElement.scrollTop || document.body.scrollTop

  function smoothscroll () {
    let currentScroll = document.documentElement.scrollTop || document.body.scrollTop

    if (currentScroll > 0 && currentScroll <= cs) {
      cs = currentScroll
      window.requestAnimationFrame(smoothscroll)
      window.scrollTo(0, currentScroll - (currentScroll / 5))
    }
  }

  smoothscroll()
})

export default router

/*
 * NOTE! VueRouter "history" mode DOESN'T works for Cordova builds,
 * it is only to be used only for websites.
 *
 * If you decide to go with "history" mode, please also open /config/index.js
 * and set "build.publicPath" to something other than an empty string.
 * Example: '/' instead of current ''
 *
 * If switching back to default "hash" mode, don't forget to set the
 * build publicPath back to '' so Cordova builds work again.
*/



// WEBPACK FOOTER //
// ./src/router/index.js